import { render, staticRenderFns } from "./CoachRow.vue?vue&type=template&id=345b3056&scoped=true"
import script from "./CoachRow.vue?vue&type=script&lang=js"
export * from "./CoachRow.vue?vue&type=script&lang=js"
import style0 from "./CoachRow.vue?vue&type=style&index=0&id=345b3056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345b3056",
  null
  
)

export default component.exports